import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function showLoader() {
  return (
    <Box 
        sx={{
            height: 500,
            paddingTop: 25,
            borderRadius: 2,
        }}    
    >
      <CircularProgress aria-label="Loading…" />
    </Box>
  );
}